module.exports = __webpack_public_path__ + "static/img/1641.b0fa2e2.png";